import { Clapperboard, FilePen } from "lucide-react";
import { ScriptEditor, ScriptView } from "./ScriptContent";
import { VideoEditor, VideoView } from "./VideoContent";

// The two plan approval workflows. Every screen in this folder is shared and
// takes one of these as `kind`; a kind only carries its wording, its routes and
// how a version is shown/edited. Mirrors helpers/approvalKinds.js in
// pluginbackendnode (`versionAuthors` included — the server enforces it, this
// only decides which buttons to show).

const script = {
  noun: "script",
  Noun: "Script",
  plural: "scripts",
  title: "Script Approval",
  api: "/scripts",
  reviewApi: "/script-review",
  route: "/scripts",
  reviewRoute: "/script-review",
  versionAuthors: ["team", "brand", "creator"],
  Icon: FilePen,
  View: ScriptView,
  Editor: ScriptEditor,
  copy: {
    listSubtitle: "Share scripts with creators and brands, collect their edits and sign-off in one place.",
    boardEmptyHint: "Add creators from this plan's lists to start sharing scripts.",
    create: "Write script",
    edit: "Edit",
    empty: "No script yet.",
    brandHeading: "Review creator scripts",
    brandSubtitle: "Edit the script, leave remarks, or approve it.",
    creatorHeading: "Review your script",
    creatorSubtitle: "Edit the script or leave remarks — the brand gives the final approval.",
  },
};

const video = {
  noun: "video",
  Noun: "Video",
  plural: "videos",
  title: "Video Approval",
  api: "/videos",
  reviewApi: "/video-review",
  route: "/videos",
  reviewRoute: "/video-review",
  // The video is the creator's deliverable; the brand reviews it.
  versionAuthors: ["team", "creator"],
  Icon: Clapperboard,
  View: VideoView,
  Editor: VideoEditor,
  copy: {
    listSubtitle: "Collect creators' draft videos before they post — the brand watches, remarks and signs off here instead of WhatsApp.",
    boardEmptyHint: "Add the creators whose scripts are approved, or paste usernames from this plan's lists.",
    create: "Upload video",
    edit: "Upload new cut / edit caption",
    empty: "No video yet.",
    brandHeading: "Review creator videos",
    brandSubtitle: "Watch each cut, leave remarks, or approve it for posting.",
    creatorHeading: "Your video for review",
    creatorSubtitle: "Upload your cut and caption here — the brand approves it before you post.",
    approvedForCreator: "Approved by the brand — you're good to post this cut with this caption.",
  },
};

// A plan goes script -> video; each board shows the other stage per creator.
script.sibling = video;
video.sibling = script;
video.importsApprovedFrom = script;

// Display order of the Scripts | Videos switcher.
export const APPROVAL_KINDS = [script, video];
export { script as scriptKind, video as videoKind };

export const canAuthorVersion = (kind, viewer) => kind.versionAuthors.includes(viewer);
